__turbopack_context__.v({
  "actions": "cookie-consent-banner-module__-vJGBa__actions",
  "banner": "cookie-consent-banner-module__-vJGBa__banner",
  "bannerInner": "cookie-consent-banner-module__-vJGBa__bannerInner",
  "message": "cookie-consent-banner-module__-vJGBa__message",
});
